import { render, staticRenderFns } from "./MyAsidebar.vue?vue&type=template&id=4a31c610&scoped=true&"
import script from "./MyAsidebar.vue?vue&type=script&lang=js&"
export * from "./MyAsidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a31c610",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/tunabaranurut/Documents/Workgrounds/Cruise/Repo/panel-spa/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a31c610')) {
      api.createRecord('4a31c610', component.options)
    } else {
      api.reload('4a31c610', component.options)
    }
    module.hot.accept("./MyAsidebar.vue?vue&type=template&id=4a31c610&scoped=true&", function () {
      api.rerender('4a31c610', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/component/common/MyAsidebar.vue"
export default component.exports